module.exports = __webpack_public_path__ + "img/OVCA_Neutrophils.a012ee50.png";